<template>
  <div class="d-discover-feed-entries">
    <DBookListEntry
      v-for="book in entries"
      :key="book.slug"
      :book="book"
      :class="{ 'background-grey-base': book.isExpanded }"
      :rating="(book.review && book.review.rating)"
      :show-author="true"
      :video-review="(book.review && book.review.has_video)"
      :with-nav="true"
    >
      <template slot="status-content">
        <div class="grid-flex grid-middle">
          <div class="grid-item status-left">
            <h5 class="space-bottom-none">
              {{ book.genre }}
            </h5>
          </div>
          <div class="grid-item-shrink status-right">
            <DuiExplicitContent v-if="book.explicit_content" />

            <span class="label-round label-xs label-white-bordered">
              <DuiIconBalloonStroke class="icon-sm" />
              <strong class="num-comments valign-middle">
                {{ book.comments_count }}
              </strong>
            </span>

            <DBookVoteButton
              v-if="isUserSignedIn"
              :book-slug="book.slug"
              class="xs"
              :display-label="false"
              :is-upvoted="book.is_upvoted"
              :num-votes="book.score"
            />

            <button
              v-else
              class="button-follow button-white-bordered button-xs"
              type="button"
              @click.stop.prevent="triggerSignupModal(book.slug)"
            >
              <DuiIconTriangle
                class="icon-xs"
                style="margin-right: 4px;"
              />
              <span class="valign-middle">{{ book.score }}</span>
            </button>
          </div>
        </div>
      </template>

      <template slot="center-content">
        <div
          class="font-alt synopsis"
          :class="{
            'blurred': book.explicit_content === 'graphic' && !shouldBeVisible[book.slug]
          }"
          v-html="getBookSynopsis(book)"
        />

        <DExplicitOverlay
          v-if="(book.explicit_content === 'graphic' && !shouldBeVisible[book.slug] )"
          class="overlay"
          is-small
          button-text="Read synopsis"
          @button-click="showContent(book.slug, $event)"
        />
      </template>
    </DBookListEntry>
  </div>
</template>

<script>
import Vue from 'vue';

import DBookListEntry from '@d-components/d-book-list-entry/d-book-list-entry.vue';
import DBookVoteButton from '@d-components/d-book-vote-button/d-book-vote-button.vue';
import DExplicitOverlay from '@d-components/d-explicit-overlay/d-explicit-overlay.vue';
import duiPlainText from '@dui/filters/dui-plain-text/dui-plain-text';
import duiTruncate from '@dui/filters/dui-truncate/dui-truncate';

export default {
  components: {
    DBookListEntry,
    DBookVoteButton,
    DExplicitOverlay,
  },
  props: {
    entries: {
      type: Array,
      required: true,
    },
    isUserSignedIn: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    shouldBeVisible: {},
  }),
  methods: {
    getBookSynopsis(book) {
      return duiTruncate(duiPlainText(book.synopsis), 175);
    },

    showContent(bookSlug, event) {
      event.preventDefault();
      event.stopPropagation();

      this.$set(this.shouldBeVisible, bookSlug, true);
    },

    triggerSignupModal(bookSlug) {
      if (this.isUserSignedIn) {
        return;
      }

      Vue.prototype.signupModal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-discover-feed-entries {
  .overlay {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .synopsis.blurred {
    filter: blur($_0-5em);

    &::after {
      background-color: getColor($translucent, dark);
      bottom: 0;
      content: '';
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>
